import { useMutation } from "@tanstack/react-query";
import { firstErrorMessage } from "../../../helpers/apiErrors";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { REACT_APP_BASE_URL } from "src/helpers/constants";

export const useResetPassword = () => {
  type UserData = {
    email: string;
  };

  const initialValues = {
    email: "",
    otp: "",
    password: "",
  };
  const navigate = useNavigate();

  const resetPassword = async (userData: UserData) => {
    try {
      
      const apiData = {
        ...userData,
        email: userData.email.toLowerCase()
      };

      const response = await fetch(`${REACT_APP_BASE_URL}/auth/user/complete-reset-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apiData),
      });

      const data = await response.json();

      if (!response.ok) {
        let errorMessage = "An unknown error occurred";
        Object.keys(data).forEach((propertyName) => {
          if (Array.isArray(data[propertyName])) {
            errorMessage = firstErrorMessage(data[propertyName]);
            toast.error(errorMessage);
          }
        });
        throw new Error("Password reset failed");
      }

      return data;
    } catch (error) {
      console.error("Error in Reset Password:", error);
      throw error;
    }
  };

  const ResetPasswordMutation = useMutation({
    mutationFn: resetPassword,
    mutationKey: ["Reset password"],
    onSuccess(data) {
      toast.success(data.message);
      navigate("/");
    },
    onError(error, variables) {
      toast.error(error.message);
      console.error("ON ERROR:", error, variables);
    },
  });

  const handleSubmit = async (
    values: { email: string; otp: string; password: string },
    { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void },
  ) => {
    try {
      setSubmitting(true);
      await ResetPasswordMutation.mutateAsync(values);
    } catch (error) {
      console.error("Password reset error", error);
    } finally {
      setSubmitting(false);
    }
  };

  return { initialValues, handleSubmit };
};
